const constants = {
  actions: {
    BROKER_LETTER_REPORT_DATA_FAILED: 'BROKER_LETTER_REPORT_DATA_FAILED_ACTION',
    BROKER_LETTER_REPORT_DATA_LOADED: 'BROKER_LETTER_REPORT_DATA_LOADED_ACTION',
    BROKER_LETTER_REPORT_DATA_LOADING: 'BROKER_LETTER_REPORT_DATA_LOADING_ACTION'
  },
  events: {
    BROKER_LETTER_REPORT_DATA_FAILED: 'BROKER_LETTER_REPORT_DATA_FAILED_EVENT',
    BROKER_LETTER_REPORT_DATA_LOADED: 'BROKER_LETTER_REPORT_DATA_LOADED_EVENT',
    BROKER_LETTER_REPORT_DATA_LOADING: 'BROKER_LETTER_REPORT_DATA_LOADING_EVENT'
  }
};

export = constants;
